<div class="jumbotron centered-text">
  U <b>{{data.selectEntities.count}}</b> {{data.selectEntities.count === 1 ? 'záboru' : 'záborů'}} bude navržen způsob vypořádání <b>{{data.details.occupationSolutionType.name}}</b>.
  <ng-container *ngIf="data.details.finalSolutionReason">
    <br/><br/>
    <span>{{ 'Důvod požadavku' }}: <b>{{data.details.finalSolutionReason}}</b></span>
  </ng-container>
  <ng-container *ngIf="data.details.occupationSolutionType.key === FinalSolutionTypesEnum.OTHER_CHANGE && data.details.finalSolutionOtherChange">
    <div class="info-label">Navrhovaný stav</div>
    <div class="flexbox-container mt-15">
      <div class="column-30">
        <div class="info-label">Typ změny</div>
        <div><strong>{{data.details.occupationSolutionType.name}}</strong></div>

        <div *ngIf="data.details.finalSolutionOtherChange.changeGeometry">
          <strong>Změna výměry a geometrie (bez GP)</strong>
        </div>
        <div *ngIf="data.details.finalSolutionOtherChange.changeWholeParcel">
          <strong>Celá parcela</strong>
        </div>
      </div>

      <div *ngIf="data.details.finalSolutionOtherChange.changeOccupationNumber || data.details.finalSolutionOtherChange.changeOccupationType" class="column-20">
        <div class="info-label">Zábor</div>
        <div *ngIf="data.details.finalSolutionOtherChange.changeOccupationNumber && data.details.finalSolutionOtherChange.newOccupationNumber" class="occupation-solution-highlight">
          č. {{data.details.finalSolutionOtherChange.newOccupationNumber}}
        </div>
        <div *ngIf="data.details.finalSolutionOtherChange.changeOccupationType && data.details.finalSolutionOtherChange.newOccupationType" class="occupation-solution-highlight">
          {{data.details.finalSolutionOtherChange.newOccupationType.name}}
        </div>
        <ng-container *ngIf="data.details.finalSolutionOtherChange.changeOccupationType && data.details.finalSolutionOtherChange.newNabyvatel">
          <div class="info-label mt-10">Nabyvatel</div>
          <div class="occupation-solution-highlight">{{ data.details.finalSolutionOtherChange.newNabyvatel.name }}</div>
          <div *ngIf="data.details.finalSolutionOtherChange.newNabyvatel.typNabyvatele" class="occupation-solution-highlight">Typ: {{ data.details.finalSolutionOtherChange.newNabyvatel.typNabyvatele }}</div>
          <div *ngIf="data.details.finalSolutionOtherChange.newNabyvatel.icoNabyvatele" class="occupation-solution-highlight">IČO: {{ data.details.finalSolutionOtherChange.newNabyvatel.icoNabyvatele }}</div>
        </ng-container>
      </div>

      <div *ngIf="data.details.finalSolutionOtherChange.changeConstructionObjects && data.details.finalSolutionOtherChange.newConstructionObjects && data.details.finalSolutionOtherChange.newConstructionObjects.length" class="column-50">
        <div class="info-label">Objektová skladba záboru</div>
        <span class="other-change-current-value">
        <div *ngFor="let co of data.details.finalSolutionOtherChange.newConstructionObjects" class="occupation-solution-highlight">{{ co | constructionObjectName }}</div>
      </span>
      </div>
    </div>
  </ng-container>
</div>
